import { Controller } from '@hotwired/stimulus'
// import { stimulus } from '~/init'

export default class extends Controller {
  static targets = ['input', 'filename', 'removeButton', 'destroy']
  static values = { defaultText: String }

  connect () {
    this.uDisplay = this.updateDisplay()
    document.addEventListener('turbo:morph', this.reconnect.bind(this))
  }

  disconnect () {
    this.uDisplay = undefined
  }

  handleFileSelect (event) {
    const file = event.target.files[0]
    if (file) {
      this.filenameTarget.textContent = file.name
    } else {
      this.filenameTarget.textContent = this.defaultTextValue
    }
    if (this.hasDestroyTarget) {
      this.destroyTarget.value = '0'
    }
    this.updateDisplay()
  }

  removeFile (event) {
    event.preventDefault()
    event.stopPropagation()
    this.inputTarget.value = ''
    this.filenameTarget.textContent = this.defaultTextValue

    // You may have hidden file input, clear it too if needed
    const hiddenInput = this.element.querySelector('.hidden-file-input')
    if (hiddenInput) {
      hiddenInput.value = ''
    }
    if (this.hasDestroyTarget) {
      this.destroyTarget.value = '1'
    }
    this.updateDisplay()
  }

  reconnect () {
    this.disconnect()
    this.connect()
  }

  updateDisplay () {
    const fileName = this.filenameTarget.textContent.trim()
    const defaultText = this.defaultTextValue.trim()
    const hasFile = fileName && fileName !== defaultText
    if (this.hasRemoveButtonTarget) {
      this.removeButtonTarget.style.display = hasFile ? 'inline-flex' : 'none'
    }
  }
}

// stimulus.register('file-upload', FileUploadController)
